// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'

export default ({ spacing }) => <div sx={{ marginY: spacing }} />
